
const PonudjeniOdgovor = ({ odgovor, tip }) => {
 

  return (
    <div className="ponudjeni-odgovor-item">
      {tip === "VISESTRUKI_IZBOR" ? (
        <label className="ponudjeni-odgovor-label">
          <input type="checkbox" name={`odgovor-${odgovor.pitanjeId}`} value={odgovor.tekstOdgovora} className="ponudjeni-odgovor-input" />
          {odgovor.tekstOdgovora}
        </label>
      ) : (
        <label className="ponudjeni-odgovor-label">
          <input type="radio" name={`odgovor-${odgovor.pitanjeId}`} value={odgovor.tekstOdgovora} className="ponudjeni-odgovor-input"/>
          {odgovor.tekstOdgovora}
        </label>
      )}
    </div>
  );
};

export default PonudjeniOdgovor;